// extracted by mini-css-extract-plugin
export default {"disableClass":"onboarding_disableClass__SfvFI","technicalElementForTour":"onboarding_technicalElementForTour__H9SJ3"};